module.exports = __webpack_public_path__ + "static/media/siddharth-vijayawada-trip-08.6c39df2f.png";